import React, {useState, useContext} from 'react';
import {UserContext} from "../common/UserContext";
import {BrandContext} from "../common/BrandContext";
import {ShortcutContext} from "../common/ShortcutContext";
import CircularLoader from "../common/CircularLoader";
import TeacherTestResultsDashboardWidget from "../dashboard/TeacherTestResultsDashboardWidget";
import TeacherTestAssignmentsDashboardWidget from "../dashboard/TeacherTestAssignmentsDashboardWidget";
import TeacherGraphTestAssignmentsWidget from "../dashboard/TeacherGraphTestAssignmentsWidget";
import TeacherTrailResultsDashboardWidget from "../dashboard/TeacherTrailResultsDashboardWidget";
import ProgressDashboardWidget from "../dashboard/ProgressDashboardWidget";
import TeacherActiveLessonsWidget from "../dashboard/TeacherActiveLessonsWidget";
import StudentActiveLessonsWidget from "../dashboard/StudentActiveLessonsWidget";
import MessageDashboardWidget from "../dashboard/MessageDashboardWidget";
import StudentDiagnosticTestResultDashboardWidget from "../dashboard/StudentDiagnosticTestResultDashboardWidget";
import StudentToDoCalendarDashboardWidget from "../dashboard/StudentToDoCalendarDashboardWidget";
import StudentToDoListDashboardWidget from "../dashboard/StudentToDoListDashboardWidget";
import StudentTasksWidget from "../dashboard/StudentTasksWidget";
import StudentTestsWidget from "../dashboard/StudentTestsWidget";
import LastLessonDashboardWidget from "../dashboard/LastLessonDashboardWidget";
import WelcomeDashboardWidget from "../dashboard/WelcomeDashboardWidget";
import StudentCompetitionsWidget from "../dashboard/StudentCompetitionsWidget";
import TeacherClassesDashboardWidget from "../dashboard/TeacherClassesDashboardWidget";
import TeacherTestsDashboardWidget from "../dashboard/TeacherTestsDashboardWidget";
import TeacherTrailsDashboardWidget from "../dashboard/TeacherTrailsDashboardWidget";
import MyCourseLastLessonDashboardWidget from "../dashboard/MyCourseLastLessonDashboardWidget";
import MyCourseNextTopicDashboardWidget from "../dashboard/MyCourseNextTopicDashboardWidget";
import StudentTestResultsDashboardWidget from "../dashboard/StudentTestResultsDashboardWidget";
import WelcomeDashboardWidgetUSA from "../dashboard/WelcomeDashboardWidgetUSA";
import StudentRecentProgressDashboardWidgetUSA from "../dashboard/StudentRecentProgressDashboardWidgetUSA";
import StudentLastLessonDashboardWidgetUSA from "../dashboard/StudentLastLessonDashboardWidgetUSA";
import StudentGameDashboardWidgetUSA from "../dashboard/StudentGameDashboardWidgetUSA";
import TeacherAssignedWorkWidgetUSA from "../dashboard/TeacherAssignedWorkWidgetUSA";
import MyCourseNextTopicDashboardWidgetUSA from "../dashboard/MyCourseNextTopicDashboardWidgetUSA";
import TeacherTrailsDashboardWidgetUSA from "../dashboard/TeacherTrailsDashboardWidgetUSA";
import TeacherClassShortcutDashboardWidget from "../dashboard/TeacherClassShortcutDashboardWidget";
import {useScreenMode} from "../common/context/ScreenModeContext";
import MyCourseLessonNavigationWidget from "../dashboard/MyCourseLessonNavigationWidget";
import WelcomeDashboardWidgetDevelopment from "../dashboard/WelcomeDashboardWidgetDevelopment";

const dashboardComponents = {
    StudentCompetitionsWidget: StudentCompetitionsWidget,
    StudentActiveLessonsWidget: StudentActiveLessonsWidget,
    StudentTasksWidget: StudentTasksWidget,
    StudentTestsWidget: StudentTestsWidget,
    TeacherActiveLessonsWidget: TeacherActiveLessonsWidget,
    TeacherClassesDashboardWidget: TeacherClassesDashboardWidget,
    LastLessonDashboardWidget: LastLessonDashboardWidget,
    MessageDashboardWidget: MessageDashboardWidget,
    ProgressDashboardWidget: ProgressDashboardWidget,
    StudentDiagnosticTestResultDashboardWidget: StudentDiagnosticTestResultDashboardWidget,
    StudentToDoCalendarDashboardWidget:  StudentToDoCalendarDashboardWidget,
    StudentToDoListDashboardWidget: StudentToDoListDashboardWidget,
    TeacherTestAssignmentsDashboardWidget: TeacherTestAssignmentsDashboardWidget,
    TeacherGraphTestAssignmentsWidget: TeacherGraphTestAssignmentsWidget,
    TeacherTestResultsDashboardWidget: TeacherTestResultsDashboardWidget,
    TeacherTrailResultsDashboardWidget: TeacherTrailResultsDashboardWidget,
    WelcomeDashboardWidget: WelcomeDashboardWidget,
    TeacherTestsDashboardWidget: TeacherTestsDashboardWidget,
    TeacherTrailsDashboardWidget: TeacherTrailsDashboardWidget,
    MyCourseLastLessonDashboardWidget: MyCourseLastLessonDashboardWidget,
    MyCourseNextTopicDashboardWidget: MyCourseNextTopicDashboardWidget,
    StudentTestResultsDashboardWidget: StudentTestResultsDashboardWidget,
    WelcomeDashboardWidgetUSA: WelcomeDashboardWidgetUSA,
    StudentRecentProgressDashboardWidgetUSA: StudentRecentProgressDashboardWidgetUSA,
    StudentLastLessonDashboardWidgetUSA: StudentLastLessonDashboardWidgetUSA,
    StudentGameDashboardWidgetUSA: StudentGameDashboardWidgetUSA,
    TeacherAssignedWorkWidgetUSA: TeacherAssignedWorkWidgetUSA,
    MyCourseNextTopicDashboardWidgetUSA: MyCourseNextTopicDashboardWidgetUSA,
    TeacherTrailsDashboardWidgetUSA: TeacherTrailsDashboardWidgetUSA,
    TeacherClassShortcutDashboardWidget: TeacherClassShortcutDashboardWidget,
    MyCourseLessonNavigationWidget: MyCourseLessonNavigationWidget,
    WelcomeDashboardWidgetDevelopment: WelcomeDashboardWidgetDevelopment
};

const ActivityDashboard = () => {
    const {user} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const {dashboardShortcuts} = useContext(ShortcutContext);
    const [isLoading, setLoading] = useState(false);
    const {smallScreenMode} = useScreenMode();

    if(isLoading) {
        return <CircularLoader/>
    }

    return (
        <div className={`ch-dashboard ${brandConfig.use2025Dashboard ? 'ch-dashboard-update' : ''}`}>
            <div className={'ch-dashboard-blks'}>
                {dashboardShortcuts.map((shortcut, index) => {
                    const dashboardComponentName = (shortcut.bodyComponent ? shortcut.bodyComponent : undefined);
                    const DashboardComponent = dashboardComponentName === undefined ? undefined : dashboardComponents[dashboardComponentName];
                    // Temporary disable for New Dashboard. Can remove once enabled in production for all Integrated maths

                    if(user.role === 'TEACHER' && shortcut.shortcutId === 134 && brandConfig.use2025Dashboard) return;
                    if((user.role === 'TEACHER' || user.role === 'STUDENT') && shortcut.shortcutId === 144 && brandConfig.use2025Dashboard) return;
                    if(shortcut.shortcutId === 149 && brandConfig.use2025Dashboard) return;
                    if(shortcut.shortcutId === 150 && brandConfig.use2025Dashboard) return;

                    if(DashboardComponent == undefined) {
                        console.log('DashboardComponent undefined', dashboardComponentName);
                        return null;
                    }

                    return React.createElement(DashboardComponent, {key: shortcut.shortcutId, classes: user.classes, className: shortcut.iconClass, highlight: shortcut.highlight});
                })}
            </div>
        </div>
    )
}

export default ActivityDashboard;